/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const AssetPurchaseCostJsonApiModel = {
  id: "",
  "asset-purchase": {
    jsonApi: "hasOne",
    type: "asset-purchases",
  },
  "asset-purchase-id": "",
  name: "",
  amount: "",
  "created-at": "",
  "updated-at": "",
};
